import { Component } from '@angular/core'
import { menu } from '../../data-access/constant/layout.constant'
import { RouterModule } from '@angular/router'
import { NgOptimizedImage } from '@angular/common'

@Component({
  selector: 'lg-menu',
  imports: [RouterModule, NgOptimizedImage],
  templateUrl: './menu.component.html',
  styleUrl: './menu.component.scss',
})
export class MenuComponent {
  protected readonly menu = menu
}
